var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.symbol.dispose.js
// module id = 178
// module chunks = 0